import React from 'react';
import SensorData from './SensorData';
import './App.css';

function App() {
    return (
        <div className="app-container">
            <SensorData />
        </div>
    );
}

export default App;